import { render, staticRenderFns } from "./FooterConfigurationSection.vue?vue&type=template&id=7e74a58f&scoped=true"
import script from "./FooterConfigurationSection.vue?vue&type=script&lang=js"
export * from "./FooterConfigurationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e74a58f",
  null
  
)

export default component.exports